/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Backtologin2Inputs */

const he_verify_backtologin2 = /** @type {(inputs: Verify_Backtologin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה להתחברות`)
};

const en_verify_backtologin2 = /** @type {(inputs: Verify_Backtologin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Login`)
};

/**
* | output |
* | --- |
* | "Back to Login" |
*
* @param {Verify_Backtologin2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const verify_backtologin2 = /** @type {((inputs?: Verify_Backtologin2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Backtologin2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_verify_backtologin2(inputs)
	return en_verify_backtologin2(inputs)
});
export { verify_backtologin2 as "verify_backToLogin" }